const receivingStatus = {
	incoming: 'incoming',
	arrivedAtPort: 'arrived%20at%20port',
	received: 'received',
	pendingPickup: 'pending%20pickup',
	inTransit: 'in%20transit',
};

export { receivingStatus };
